document.addEventListener('DOMContentLoaded', function () {
	var form = document.querySelector('.js-newsletter-form');
	if (!form) {
		return;
	}
	var msg = document.getElementById('newsletter-signup-message');
	form.addEventListener('submit', function (e) {
		e.preventDefault();
		msg.textContent = '';
		var email = form.email.value;
		var firstNameField = form.querySelector('[name="first_name"]');
		var lastNameField = form.querySelector('[name="last_name"]');
		var turnstileResponse = document.querySelector('[name="cf-turnstile-response"]');
		var first_name = firstNameField ? firstNameField.value : '';
		var last_name = lastNameField ? lastNameField.value : '';
		var turnstile_response = turnstileResponse ? turnstileResponse.value : '';
		if (!email) {
			msg.textContent = 'Please enter your email.';
			msg.className = 'custom-newsletter__msg--error';
			return;
		}
		var xhr = new XMLHttpRequest();
		xhr.open('POST', (typeof bmNewsletterForm !== 'undefined' ? bmNewsletterForm.ajaxUrl : '/wp-admin/admin-ajax.php'));
		xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
		xhr.onload = function () {
			try {
				var resp = JSON.parse(xhr.responseText);
				var message = (resp.data && resp.data.message) ? resp.data.message : resp.data;
				if (resp.success) {
					msg.textContent = message;
					msg.className = 'custom-newsletter__msg--success';
					form.reset();
				} else {
					msg.textContent = message || 'Error. Please try again.';
					msg.className = 'custom-newsletter__msg--error';
				}
			} catch (e) {
				msg.textContent = 'Unexpected error.';
				msg.className = 'custom-newsletter__msg--error';
			}
		};
		var params = 'action=bm_newsletter_signup&email=' + encodeURIComponent(email);
		if (firstNameField) {
			params += '&first_name=' + encodeURIComponent(first_name);
		}
		if (lastNameField) {
			params += '&last_name=' + encodeURIComponent(last_name);
		}
		if (turnstileResponse) {
			params += '&turnstile_response=' + encodeURIComponent(turnstile_response);
		}
		xhr.send(params);
	});
});
